import { render } from "./reset-password-modal.vue?vue&type=template&id=d6a9dbde&scoped=true"
import script from "./reset-password-modal.vue?vue&type=script&lang=js"
export * from "./reset-password-modal.vue?vue&type=script&lang=js"

import "./reset-password-modal.vue?vue&type=style&index=0&id=d6a9dbde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a9dbde"]])

export default __exports__